import styled from 'styled-components';

const LeftColumn = styled.div`
  width: ${props => props.width || '25%'};
  height: inherit;
  overflow-y: auto;
`;
export default styled(LeftColumn)``;
